import axios from 'axios'

// 建立 axios 實例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 請求攔截器
service.interceptors.request.use(
  config => {
    // 開發階段：用 Header 帶入使用者（後端 UserContext 會讀 X-User-Id / X-User-Name）
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['X-User-Id'] = config.headers['X-User-Id'] || token
      try {
        const raw = localStorage.getItem('userInfo')
        if (raw && !config.headers['X-User-Name']) {
          const info = JSON.parse(raw)
          const userName = info.userName || info.UserName
          if (userName) config.headers['X-User-Name'] = userName
        }
      } catch {}
    }
    return config
  },
  error => {
    console.error('請求錯誤:', error)
    return Promise.reject(error)
  }
)

// 回應攔截器
service.interceptors.response.use(
  response => {
    // 統一處理 API 回應格式
    const res = response.data
    // 支援 Success 和 success 兩種格式
    if ((res.Success !== undefined && !res.Success) || (res.success !== undefined && !res.success)) {
      // API 返回錯誤，優先顯示後端訊息，無則用操作失敗（避免一律顯示未知錯誤）
      const message = (res.Message || res.message || '').trim() || (res.errorCode || '').trim() || '操作失敗'
      console.error('API 錯誤:', message)
      return Promise.reject(new Error(message))
    }
    return res
  },
  error => {
    console.error('回應錯誤:', error)
    const message = error.response?.data?.message || error.response?.data?.Message || error.message || '請求失敗'
    return Promise.reject(new Error(message))
  }
)

export default service

